<div>
  <section class="section_one">
    <div class="">
      <div class="row">
        <div class="col-md-12">

          <div class="ibox">
            <div class="ibox-title report_flexweb">
              <div>
                <h5> ATTENDANCE SUMMARY REPORT</h5>
              </div>
              <div class="icon_flex  ">
                <p class="line12"></p>
                <div class="icon_flex">
                  <a class="dload_rpt" (click)="filterdialog()"> <span><img src="../../assets/image/Filter.svg.svg"
                        alt=""></span>&nbsp;FilterBy</a>
                  <img src="../../assets/image/arrow.svg">
                </div>
                <div class="icon_flex">
                  <a class="dload_rpt" (click)="exporttoexcel()"> <span><img src="../../assets/image/Excel.svg.svg"
                        alt=""></span>&nbsp;Export in Excel</a>
                </div>
              </div>
            </div>
            <div class="ibox-content">
              <mat-card>
                <ng-container *ngIf="isDataAvailable; else noData">

                  <div class="searchpaginator">
                    <div class="table_search">
                      <input type="text" class="form-control" (keyup)="applyFilter($event)" placeholder="Search" [(ngModel)]="searchInputtext" />
                    </div>
                    <div>
                      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <mat-card-content>

                      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>


                        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header
                            [ngClass]="isNumericColumn(column) ? 'numeric-cell' : 'string-cell'">
                            <div class="header-content">
                              <span class="field-label">{{ getColumnLabel(column) }}</span>
                              <span class="week-date">{{ getColumnDateRange(column) }}</span>

                            </div>
                          </th>
                          <td mat-cell *matCellDef="let element" [ngClass]="isNumericColumn(column) ? 'numeric-cell' : 'string-cell'">
                            <ng-container *ngIf="column === 'attendDate'; else otherData">
                              {{ element[column] | date: 'dd/MM/yyyy' }}
                            </ng-container>
                            <ng-template #otherData>
                              {{ element[column] || '-' }}
                            </ng-template>
                          </td>
                          
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="displayedColumns  sticky: true"></tr>


                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>
                    </mat-card-content>
                  </div>

                </ng-container>
              </mat-card>
              <ng-template #noData>
                <section class="section_one">
                  <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                      <div>
                        <div class="nodata_center">
                          <figure class="mb-0">
                            <img src="../../assets/image/nodata.png " alt="nodata" class="nodata">
                          </figure>
                          <p class="no_data">No Data Found</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>